module.exports = __webpack_public_path__ + "img/bbh.483b7702.jpg";